import { call, put, takeEvery } from 'redux-saga/effects'
import API from '../../API';
// import {toastr} from 'react-redux-toastr'
import axios from 'axios';


async function getApi(data) {
    const apiUrl = API.baseURL + `/user_profile.json`;
    try {
        const response = axios.get(apiUrl, API.options)
        return await response;
    } catch (error) {
        throw error;
    }
}

function* getProfileData(action) {
    try {
        const response = yield call(getApi, action.data);
        console.log('Profile API response:', response.data);
        console.log('Profile data from API:', response.data.data);
        console.log('is_pro_provider from API:', response.data.data?.is_pro_provider);
        
        if (response.status == 200 || response.status == 201) {
            // toastr.success('Pegister personal Success', 'You are successfully completed the first step ');
        } else {
            // response.errors.length!=0&&toastr.error('Pegister personal  failed', response.errors[0]);
        }
        yield put({ type: 'GET_PROFILE_DATA_SUCCESS', data: response.data.data });
    } catch (e) {
        yield put({ type: 'GET_PROFILE_DATA_FAILED', message: e.message });
    }
}

function* getProfileDataSaga() {
    yield takeEvery('GET_PROFILE_DATA_REQUESTED', getProfileData);
}

export default getProfileDataSaga;